import { render, staticRenderFns } from "./grid-col-item.vue?vue&type=template&id=533fc3ce&scoped=true&"
import script from "./grid-col-item.vue?vue&type=script&lang=js&"
export * from "./grid-col-item.vue?vue&type=script&lang=js&"
import style0 from "./grid-col-item.vue?vue&type=style&index=0&id=533fc3ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533fc3ce",
  null
  
)

export default component.exports